import axiosConfig from "./axiosConfig";

/**
 * Service for interacting with tax rate API endpoints
 */
const taxService = {
  /**
   * Get the default tax rate
   * @returns {Promise<Object>} Default tax rate
   */
  getDefaultTaxRate: async () => {
    const response = await axiosConfig.get("/tax/default");
    return response.data;
  },

  /**
   * Update the default tax rate
   * @param {Object} taxRateData - Tax rate data
   * @returns {Promise<Object>} Updated tax rate
   */
  updateDefaultTaxRate: async (taxRateData) => {
    const response = await axiosConfig.put("/tax/default", taxRateData);
    return response.data;
  },

  /**
   * Calculate tax for an order
   * @param {Object} params - Tax calculation parameters
   * @param {number} params.subtotal - Order subtotal
   * @returns {Promise<Object>} Tax calculation result
   */
  calculateTax: async (params = {}) => {
    const response = await axiosConfig.post("/tax/calculate", params);
    return response.data;
  },
};

export default taxService;
